import React from "react";
import { Icon } from "./TableElements";
import Tooltip from "../components/Tooltip";

const InfoTooltip = ({ tooltipText, iconStyles }) => {
  return (
    <Tooltip text={tooltipText}>
      <Icon className="fi fi-rr-info" style={iconStyles}></Icon>
    </Tooltip>
  );
};

export default InfoTooltip;
